import React from 'react';

export default () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5625rem"
      height="1.5625rem"
      viewBox="0 0 25 25"
      version="1.1">
      <title>Appointment Description</title>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="Right-hand-vhc-tools"
          transform="translate(-19, -200)"
          fill="#54617A"
          fillRule="nonzero">
          <g id="Group" transform="translate(19.3, 200)">
            <path
              d="M24.6875,1.82291667 C24.6875,0.833333333 23.8541667,0 22.8645833,0 L22.34375,0 C21.3541667,0 20.5208333,0.833333333 20.5208333,1.82291667 L20.5208333,16.25 C20.5208333,16.40625 20.46875,16.6145833 20.5208333,16.7708333 L22.0833333,21.1979167 C22.1354167,21.40625 22.34375,21.5625 22.5520833,21.5625 C22.7604167,21.5625 22.96875,21.40625 23.0208333,21.1979167 L24.5833333,16.7708333 C24.6354167,16.6145833 24.5833333,16.4583333 24.5833333,16.4583333 L24.5833333,1.82291667 L24.6875,1.82291667 Z M22.6041667,19.4791667 L21.7708333,17.1354167 L23.4375,17.1354167 L22.6041667,19.4791667 Z M23.6458333,16.09375 L21.5625,16.09375 L21.5625,4.42708333 L23.6458333,4.42708333 L23.6458333,16.09375 Z M23.6458333,3.38541667 L21.5625,3.38541667 L21.5625,1.82291667 C21.5625,1.40625 21.9270833,1.04166667 22.34375,1.04166667 L22.8645833,1.04166667 C23.28125,1.04166667 23.6458333,1.40625 23.6458333,1.82291667 L23.6458333,3.38541667 Z"
              id="Shape"
            />
            <path
              d="M12.1354167,24.84375 L18.28125,18.6979167 C18.3854167,18.59375 18.4375,18.4895833 18.4375,18.3333333 L18.4375,0.520833333 C18.4375,0.208333333 18.2291667,0 17.9166667,0 L0.520833333,0 C0.208333333,0 0,0.208333333 0,0.520833333 L0,24.4791667 C0,24.7916667 0.208333333,25 0.520833333,25 L11.7708333,25 C11.875,25 12.03125,24.9479167 12.1354167,24.84375 Z M12.2395833,23.2291667 L12.2395833,18.8541667 L16.6145833,18.8541667 L12.2395833,23.2291667 Z M11.1979167,18.3333333 L11.1979167,23.9583333 L0.989583333,23.9583333 L0.989583333,1.04166667 L17.34375,1.04166667 L17.34375,17.8125 L11.71875,17.8125 C11.4583333,17.8125 11.1979167,18.0208333 11.1979167,18.3333333 Z"
              id="Shape"
            />
            <path
              d="M2.8125,4.27083333 L15.5729167,4.27083333 C15.8854167,4.27083333 16.09375,4.0625 16.09375,3.75 C16.09375,3.4375 15.8854167,3.22916667 15.5729167,3.22916667 L2.8125,3.22916667 C2.5,3.22916667 2.29166667,3.4375 2.29166667,3.75 C2.29166667,4.01041667 2.5,4.27083333 2.8125,4.27083333 Z"
              id="Path"
            />
            <path
              d="M2.8125,8.07291667 L15.5729167,8.07291667 C15.8854167,8.07291667 16.09375,7.86458333 16.09375,7.55208333 C16.09375,7.23958333 15.8854167,7.03125 15.5729167,7.03125 L2.8125,7.03125 C2.5,7.03125 2.29166667,7.23958333 2.29166667,7.55208333 C2.29166667,7.8125 2.5,8.07291667 2.8125,8.07291667 Z"
              id="Path"
            />
            <path
              d="M2.8125,11.875 L15.5729167,11.875 C15.8854167,11.875 16.09375,11.6666667 16.09375,11.3541667 C16.09375,11.0416667 15.8854167,10.8333333 15.5729167,10.8333333 L2.8125,10.8333333 C2.5,10.8333333 2.29166667,11.0416667 2.29166667,11.3541667 C2.29166667,11.6145833 2.5,11.875 2.8125,11.875 Z"
              id="Path"
            />
            <path
              d="M16.09375,15.15625 C16.09375,14.84375 15.8854167,14.6354167 15.5729167,14.6354167 L2.8125,14.6354167 C2.5,14.6354167 2.29166667,14.84375 2.29166667,15.15625 C2.29166667,15.46875 2.5,15.6770833 2.8125,15.6770833 L15.5729167,15.6770833 C15.8854167,15.6770833 16.09375,15.46875 16.09375,15.15625 Z"
              id="Path"
            />
            <path
              d="M8.48958333,18.4375 L2.8125,18.4375 C2.5,18.4375 2.29166667,18.6458333 2.29166667,18.9583333 C2.29166667,19.2708333 2.5,19.4791667 2.8125,19.4791667 L8.48958333,19.4791667 C8.80208333,19.4791667 9.01041667,19.2708333 9.01041667,18.9583333 C9.01041667,18.6979167 8.75,18.4375 8.48958333,18.4375 Z"
              id="Path"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
